import { Modal, Box, Typography, IconButton, Divider, List, ListItem, ListItemText } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function MakeupDocModal({ open, onClose }) {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 4,
                    minWidth: 350,
                    maxWidth: 600,
                    outline: 'none',
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                        Makeup Scheduling Documentation
                    </Typography>
                    <IconButton onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Divider sx={{ mb: 2 }} />
                <List dense>
                    <ListItem>
                        <ListItemText
                            primary="All makeup loops are created based on the original event date (NOT the date you issue it)."
                            primaryTypographyProps={{ fontSize: '14px' }}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            primary="For example, if the event is on 2025-01-01, the makeup class window will begin from 2025-01-04, regardless of when you issue the loop."
                            primaryTypographyProps={{ fontSize: '14px' }}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            primary="If a teacher or parent contacts the office for manual attention, ensure you delete the exact loop from the dashboard."
                            primaryTypographyProps={{ fontSize: '14px', color: 'red' }}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            primary="If you forget to delete the loop, it will continue to track and send emails to the teacher and parent."
                            primaryTypographyProps={{ fontSize: '14px', color: 'red' }}
                        />
                    </ListItem>
                </List>
                <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 'bold', fontSize: '18px' }}>    
                    Manual Makeup Classes
                </Typography>
                <List dense>
                    <ListItem>
                        <ListItemText
                            primary="Please refrain from issuing the loop for a past date."
                            primaryTypographyProps={{ fontSize: '14px' }}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            primary="Refresh the page after adding a manual makeup class. If it doesn't appear, check your email as it may have been flagged."
                            primaryTypographyProps={{ fontSize: '14px' }}
                        />
                    </ListItem>
                </List>
                <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 'bold', fontSize: '18px' }}>
                    Additional Notes
                </Typography>
                <List dense>
                    <ListItem>
                        <ListItemText
                            primary="Parents (1:1) and teachers (group) can confirm and create a new module. The finished (approved) loops will not show up in the dashboard."
                            primaryTypographyProps={{ fontSize: '14px' }}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            primary="The confirmed module can be created up to one day before the event, at the latest."
                            primaryTypographyProps={{ fontSize: '14px' }}
                        />
                    </ListItem>
                </List>
            </Box>
        </Modal>
    );
}